export const CURRENT_SONG = 'CURRENT_SONG';
export const NEXT_SONG = 'NEXT_SONG';
export const PREV_SONG = 'PREV_SONG';
export const ADD_FAVSONG = 'ADD_FAVSONG';
// export const BUY_ITEM = 'BUY_ITEM';
// export const PLACE_ORDER = 'PLACE_ORDER';
// export const SINGLE_BUY  = 'SINGLE_BUY';
// export const LOGIN_START = 'LOGIN_START';
// export const LOGOUT = 'LOGOUT';